import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { MsalGuard } from '@azure/msal-angular';
import { GroupAccessGuard } from './guards/group-access.guard';
import { ListComponent } from './pages/list/list';

export const routes: Routes = [
    {
        path:'',
        redirectTo:'list',
        pathMatch:'full'
    },
    {
        path:'list',
        component:ListComponent,
        canActivate: [ GroupAccessGuard, MsalGuard],
    },
    {
        path: 'Auth',
        component: LoginComponent,
    },
    {
        path: '**',
        redirectTo: '/Auth',
        pathMatch: 'full'
    }
];
